import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import stl from "./CarReportSection.module.css";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
var SingleInspectionItem = function SingleInspectionItem(props) {
  return /*#__PURE__*/React.createElement("button", {
    className: stl.siiContainer,
    onClick: props.onClick && props.onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.ssi1
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    src: props.icon,
    alt: "icon",
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("h3", null, props.text)), /*#__PURE__*/React.createElement("div", {
    className: stl.ssi2
  }, props.numberOfPoints ? /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    src: CDN_LINK + "/assets/images/post_exclamation.svg",
    alt: "",
    width: 22,
    height: 22
  }) : /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    src: CDN_LINK + "/assets/images/post_check_mark.svg",
    alt: "icon",
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    src: CDN_LINK + "/assets/images/mobileArrL.png",
    alt: "arr",
    className: stl.arrPoint,
    width: 25,
    height: 25
  })));
};
export default SingleInspectionItem;